import dayjs from 'dayjs';

/**
 * Format date object or string date presentation to the human readable Date format
 */
export const getFormattedDate = (date: Date | string | undefined): string =>
  date ? dayjs(date).format('YYYY/MM/DD') : '';

/**
 * Format date object or string date presentation to the human readable DateTime format
 */
export const getFormattedDateTime = (date: Date | string | undefined): string =>
  date ? dayjs(date).format('YYYY/MM/DD HH:mm') : '';
